import { render } from "./KeywordHomeView.vue?vue&type=template&id=0af899af&ts=true"
import script from "./KeywordHomeView.vue?vue&type=script&lang=ts"
export * from "./KeywordHomeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__